function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconForwardDeliveryAssignedValid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    id: "screenshot-350a1f58-3f4d-809a-8006-0375448b168c",
    viewBox: "0 0 20 20",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-350a1f58-3f4d-809a-8006-0375448b168c",
    width: 800,
    height: 800,
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-350a1f58-3f4d-809a-8006-0375448be424",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-350a1f58-3f4d-809a-8006-0375448be424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none"
    },
    ry: 0,
    fill: "none",
    rx: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-350a1f58-3f4d-809a-8006-0375448c2cd6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-350a1f58-3f4d-809a-8006-0375448c2cd6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.637,8.144L13.011,7.518C12.896,7.402,12.709,7.402,12.594,7.518L8.835,11.276L7.048,9.474C6.932,9.359,6.746,9.359,6.629,9.474L6.003,10.101C5.888,10.217,5.888,10.404,6.003,10.519L8.624,13.158C8.739,13.273,8.926,13.273,9.041,13.158L13.637,8.562C13.754,8.446,13.754,8.259,13.637,8.144ZZM10.000,1.875C5.512,1.875,1.875,5.513,1.875,10.000C1.875,14.487,5.512,18.125,10.000,18.125C14.488,18.125,18.125,14.487,18.125,10.000C18.125,5.513,14.488,1.875,10.000,1.875ZZM10.000,16.250C6.549,16.250,3.750,13.451,3.750,10.000C3.750,6.548,6.549,3.750,10.000,3.750C13.452,3.750,16.250,6.548,16.250,10.000C16.250,13.451,13.452,16.250,10.000,16.250ZZ",
    style: {
      fill: "rgb(78, 159, 61)",
      fillOpacity: 1
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForwardDeliveryAssignedValid);
export default __webpack_public_path__ + "static/media/icon-forward-delivery-assigned-valid.9833cd98a3efa9fea2bbcdb73b95a7bb.svg";
export { ForwardRef as ReactComponent };